namespace GeniuzPOS.PosShift {
    export interface PsPosShiftControlForm {
        ShiftStatus: Serenity.LookupEditor;
    }

    export class PsPosShiftControlForm extends Serenity.PrefixedContext {
        static formKey = 'PosShift.PsPosShiftControl';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsPosShiftControlForm.init)  {
                PsPosShiftControlForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;

                Q.initFormType(PsPosShiftControlForm, [
                    'ShiftStatus', w0
                ]);
            }
        }
    }
}
